export default "__VITE_ASSET__DTy3UNuQ__"